var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 287.599,
    viewBox: "0 0 374.3 287.599",
    width: 374.3,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h374.3v287.599h-374.3z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h311.093v24.155h-311.093z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h125.488v178.498h-125.488z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h39.77v59.493h-39.77z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52.712v67.47h-52.712z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.825v7.825h-7.825z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.824v7.825h-7.824z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.008v9.814h-11.008z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.011v9.813h-11.011z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.007v9.814h-11.007z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.006v9.809h-11.006z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.011v9.814h-11.011z"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.026v9.808h-11.026z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.006v9.814h-11.006z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.011v9.809h-11.011z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.011v9.812h-11.011z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h31.558v28.149h-31.558z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h29.113v24.567h-29.113z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h63.2v89.919h-63.2z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20.031v29.971h-20.031z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h26.567v34.006h-26.567z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.945v3.944h-3.945z"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.945v3.945h-3.945z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.548v4.943h-5.548z"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.547v4.939h-5.547z"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.545v4.943h-5.545z"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.547v4.942h-5.547z"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.547v4.943h-5.547z"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.548v4.942h-5.548z"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h15.836v14.196h-15.836z"
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h14.678v12.386h-14.678z"
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h22.2v10.887h-22.2z"
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30.742v20.034h-30.742z"
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h31.717v15.555h-31.717z"
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h43.92v28.636h-43.92z"
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h22.201v10.906h-22.201z"
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30.744v20.034h-30.744z"
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h84.179v14.64h-84.179z"
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h65.153v2.093h-65.153z"
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h26.018v26.132h-26.018z"
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h233.107v7.693h-233.107z"
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h70.234v4.681h-70.234z"
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.818v2.818h-2.818z"
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.819v2.818h-2.819z"
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m391.735 313.01a29.556 29.556 0 0 1 -2.749 1.431c-.967.367-2.159.655-2.4 1.647a1.831 1.831 0 0 0 .08 1 3.729 3.729 0 0 0 1.131 1.633 6.518 6.518 0 0 0 3.979 9.084c.276.446.538.9.776 1.365a4.5 4.5 0 0 1 .638 2.664 8.015 8.015 0 0 0 -.732.9 17.224 17.224 0 0 0 -2.2 4.893 51.823 51.823 0 0 0 -1.768 6.687 50.266 50.266 0 0 0 -2.632 5.709 12.88 12.88 0 0 1 -3.433-.461l-3.089-.7a6.977 6.977 0 0 1 -3.041-1.219c-.447-.367-.794-.853-1.248-1.215s-1.365-.788-1.866-.484a1.446 1.446 0 0 0 -.252.194c-.454-.918-.886-1.83-1.412-2.719a5.166 5.166 0 0 0 -3.312-2.62 3.372 3.372 0 0 0 -2.488.579 2 2 0 0 0 -.732 2.664 4.91 4.91 0 0 0 .508.52 10.684 10.684 0 0 1 1.131 1.57 8.014 8.014 0 0 0 4.937 3.206l-.128.366a5.637 5.637 0 0 0 -.674 2.471l13.739 4.7a8.475 8.475 0 0 0 2.765.611 4.478 4.478 0 0 0 1.1-.146v.732c.036 4.827-.732 9.622-.875 14.444a3.747 3.747 0 0 0 .553 2.517 2.817 2.817 0 0 0 2.69.732 6.038 6.038 0 0 0 .68-.153 25.329 25.329 0 0 1 .7 3.7l.908 6.536a9.938 9.938 0 0 1 .143 2.028 14.35 14.35 0 0 1 -1.5 4.322c-.585 1.42-.933 3.11-.165 4.436.241.41.575.76.791 1.182a4.8 4.8 0 0 1 .366 2.079q.085 2.956.161 5.922a.67.67 0 0 0 -.461.092c-.76.592-.678 3.414-.732 4.289-.059 1.464 0 2.957-.08 4.436a26.452 26.452 0 0 1 -.955 5.889 3.764 3.764 0 0 1 -.838 1.687 3.563 3.563 0 0 1 -1.489.772 17.009 17.009 0 0 1 -5.64.768 5.567 5.567 0 0 0 -2.295.194 1.58 1.58 0 0 0 -1.036 1.83 2.306 2.306 0 0 0 1.511 1.138 23.975 23.975 0 0 1 4.026 1.852 10.9 10.9 0 0 0 1.556.882 8.018 8.018 0 0 0 1.6.4l6.488 1.119c1.329.226 2.928.367 3.774-.732a3.325 3.325 0 0 0 .5-2.152 28.62 28.62 0 0 1 -.138-4.417 13.6 13.6 0 0 1 .681-2.537q.967-2.88 1.946-5.757a30.253 30.253 0 0 0 1.563-5.889 2.2 2.2 0 0 0 -.475-2.024 1.288 1.288 0 0 0 -.484-.248c-.022-1.765-.253-3.532-.153-5.3.025-.439.069-.878.106-1.321a6.4 6.4 0 0 1 .9 1.068c.626.98.856 2.276 1.811 2.928.813.553 2.017.527 2.588 1.333a3.733 3.733 0 0 1 .41.991 7.064 7.064 0 0 0 1.464 2.324 11.743 11.743 0 0 0 .9 2.321q.809 1.709 1.611 3.407a39.648 39.648 0 0 0 1.83 3.576 10.063 10.063 0 0 1 1.225 2.365 5.427 5.427 0 0 1 -1.658 5.124 14.261 14.261 0 0 1 -4.82 2.811 1.344 1.344 0 0 0 -.491.293.948.948 0 0 0 -.223.637 2.065 2.065 0 0 0 1.494 1.83 5.579 5.579 0 0 0 2.5.091 37.125 37.125 0 0 0 13.476-3.982 4.747 4.747 0 0 0 1.607-1.244 1.877 1.877 0 0 0 .279-1.9 3.5 3.5 0 0 0 -.794-.882 10.555 10.555 0 0 1 -2.737-5.9 60.526 60.526 0 0 0 -1.142-6.518 21.546 21.546 0 0 0 -1.289-3.173c-.366-.783-.829-2.316-1.5-2.866a.984.984 0 0 0 -.46-.223 5.437 5.437 0 0 0 -1.323-1.763c-1.047-.948-2.324-1.7-3.022-2.928a6.662 6.662 0 0 0 -.706-1.2c-.472-.52-1.219-.732-1.655-1.281a3.678 3.678 0 0 1 -.366-2.631c.072-.9 0-1.988-.783-2.463-.468-.289-1.072-.26-1.559-.516a2.258 2.258 0 0 1 -1.007-2.112c.015-.824.271-1.625.337-2.448.207-2.621-1.521-5.226-.857-7.767a15.8 15.8 0 0 1 1.259-2.7 5.586 5.586 0 0 0 .366-.93 13.107 13.107 0 0 0 3.565.861c-2.017-4.524-1.5-9.779-2.445-14.64l.121-.164a7.629 7.629 0 0 0 1.544-4.341c0-1.808-.845-3.5-1.225-5.27-.326-1.5-.312-3.078-.732-4.556a13.765 13.765 0 0 0 -1.157-2.642q-.684-1.271-1.438-2.5-.7-2.327-1.409-4.656a22.5 22.5 0 0 0 -2.617-6.273c-.469-.691-.611-2.086-1.332-2.5a3.22 3.22 0 0 0 -1.9-.333 3.56 3.56 0 0 1 -2.039-2.522 2.454 2.454 0 0 1 .073-.732h.125c1.61-.147 2.426-1.567 3.265-2.811 1.354-2.013.838-4.736 0-7.027a4.755 4.755 0 0 0 -1.1-1.935c-1.175-1.1-3.034-.857-4.55-1.387-.509-.176-.985-.443-1.5-.567a4.5 4.5 0 0 0 -2.983.56",
    transform: "translate(-364.715 -312.394)"
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h9.375v27.361h-9.375z"
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h26.958v41.87h-26.958z"
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h15.941v18.212h-15.941z"
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h155.2v66.859h-155.2z"
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.787v38.93h-11.787z"
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h10.244v8.121h-10.244z"
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h10.504v24.62h-10.504z"
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h13.965v11.206h-13.965z"
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h13.188v14.831h-13.188z"
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "error_img_svg__ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18.981v21.355h-18.981z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__b)",
    opacity: 0.1,
    transform: "translate(15.969 229.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m186.65 447.6c85.906 0 155.546 5.407 155.546 12.078s-69.641 12.077-155.546 12.077-155.55-5.407-155.55-12.077 69.645-12.078 155.55-12.078",
    fill: "#4181ff",
    transform: "translate(-31.104 -447.6)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__c)",
    opacity: 0.1,
    transform: "translate(248.812 33.682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m564.521 305.425c-.929-2.822-4.7-4.121-8.418-2.9a9.086 9.086 0 0 0 -1.548.67 6.989 6.989 0 0 0 -.732-.169 8.205 8.205 0 0 0 .231-2.488 9 9 0 0 0 3.989-7.858 9.013 9.013 0 0 0 3.974-7.858 8.694 8.694 0 0 0 3.012-3.412c1.793-3.55 1.05-7.539-1.659-8.915s-6.369.4-8.162 3.945a8.672 8.672 0 0 0 -.963 4.447 9.015 9.015 0 0 0 -3.974 7.858 9.014 9.014 0 0 0 -3.975 7.858 9.019 9.019 0 0 0 -3.989 7.861 8.7 8.7 0 0 0 -3.012 3.411 9.324 9.324 0 0 0 -.76 2.1 7.749 7.749 0 0 0 -1.624-1.728 9.293 9.293 0 0 0 -.367-1.647c-1.222-3.722-4.5-5.991-7.319-5.061s-4.121 4.7-2.9 8.417a8.444 8.444 0 0 0 2.764 4.055 9.256 9.256 0 0 0 .367 1.647 8.052 8.052 0 0 0 3.714 4.666 8.521 8.521 0 0 0 -.3 1.427 9.257 9.257 0 0 0 -2.76 5.46 9.247 9.247 0 0 0 -2.76 5.46 9.02 9.02 0 0 0 -1.83 2.492c-1.8 3.55-1.054 7.543 1.659 8.915s6.369-.392 8.165-3.945a9.011 9.011 0 0 0 .915-2.96 9.258 9.258 0 0 0 2.76-5.46 9.248 9.248 0 0 0 2.76-5.46 9.229 9.229 0 0 0 2.726-5.46 9.228 9.228 0 0 0 2.765-5.468 8.819 8.819 0 0 0 1.244-1.464 8.585 8.585 0 0 0 4.492-.282 9.089 9.089 0 0 0 1.548-.669 8.495 8.495 0 0 0 4.911-.176c3.7-1.209 5.983-4.488 5.057-7.313",
    fill: "#3f3d56",
    transform: "translate(-504.051 -166.052)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__d)",
    opacity: 0.1,
    transform: "translate(20.877 115.855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m588.054 315.4a7.841 7.841 0 0 1 -1.259 1.006 8.412 8.412 0 0 1 -.406 3.085 9.575 9.575 0 0 0 .769-1.255 9.024 9.024 0 0 0 .9-2.833z",
    transform: "translate(-555.023 -303.012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.8 300.1a7.851 7.851 0 0 1 -1.259 1.006 8.416 8.416 0 0 1 -.406 3.085 9.406 9.406 0 0 0 .768-1.259 9.1 9.1 0 0 0 .9-2.833z",
    transform: "translate(-558.791 -295.563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.693 292.88a8.029 8.029 0 0 1 .062-1.614 9.119 9.119 0 0 0 -1.749 2.4 9.393 9.393 0 0 0 -.553 1.365 8.327 8.327 0 0 1 2.24-2.156",
    transform: "translate(-549.702 -291.266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.677 384.466a8.653 8.653 0 0 1 1.08-1.237 8.4 8.4 0 0 1 .318-1.464 9.2 9.2 0 0 0 -.838 1.358 9.382 9.382 0 0 0 -.56 1.343z",
    transform: "translate(-527.914 -335.302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.052 373.88a8.651 8.651 0 0 1 1.08-1.237 8.355 8.355 0 0 1 .3-1.427 9.39 9.39 0 0 0 -.8 1.313 9.791 9.791 0 0 0 -.579 1.351",
    transform: "translate(-530.53 -330.169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.474 330.63a7.622 7.622 0 0 1 -1.256 1 8.2 8.2 0 0 1 -.231 2.488 6.87 6.87 0 0 1 .732.169 9.047 9.047 0 0 1 1.548-.67c3.726-1.222 7.492.077 8.418 2.9a4.277 4.277 0 0 1 .117 2.2 5.027 5.027 0 0 0 1.208-4.809c-.93-2.822-4.7-4.121-8.418-2.9a9.028 9.028 0 0 0 -1.548.67 7.017 7.017 0 0 0 -.732-.169c.07-.3.122-.585.162-.877",
    transform: "translate(-551.422 -310.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.7 392.366a9.185 9.185 0 0 0 -.839 1.358 9.683 9.683 0 0 0 -.563 1.369 8.972 8.972 0 0 1 1.1-1.244 8.3 8.3 0 0 1 .3-1.483",
    transform: "translate(-525.296 -340.461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.915 308.179a8.088 8.088 0 0 1 .062-1.614 9.123 9.123 0 0 0 -1.749 2.4 9.415 9.415 0 0 0 -.553 1.365 8.328 8.328 0 0 1 2.24-2.156",
    transform: "translate(-545.917 -298.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.508 371.067a8.888 8.888 0 0 1 -.367 1.6 9.806 9.806 0 0 0 .766-1.259 9.325 9.325 0 0 0 .6-1.464 8.846 8.846 0 0 1 -1 1.12",
    transform: "translate(-542.251 -329.552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.757 392.324a8.847 8.847 0 0 1 -.366 1.6 9.353 9.353 0 0 0 .768-1.259 9.635 9.635 0 0 0 .6-1.464 8.645 8.645 0 0 1 -1 1.12",
    transform: "translate(-537.021 -339.895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m555.133 381.709a8.8 8.8 0 0 1 -.367 1.6 9.791 9.791 0 0 0 .783-1.237 9.318 9.318 0 0 0 .6-1.464 8.837 8.837 0 0 1 -1.013 1.1",
    transform: "translate(-539.636 -334.741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.883 360.414a8.8 8.8 0 0 1 -.366 1.6 9.538 9.538 0 0 0 .765-1.256 9.332 9.332 0 0 0 .6-1.489 8.456 8.456 0 0 1 -1 1.146",
    transform: "translate(-544.867 -324.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.306 331.923c2.825-.926 6.1 1.339 7.32 5.062a9.362 9.362 0 0 1 .366 1.65 7.739 7.739 0 0 1 1.625 1.728 9.34 9.34 0 0 1 .76-2.1c.128-.249.268-.484.41-.732a7.729 7.729 0 0 0 -1.464-1.53 9.329 9.329 0 0 0 -.366-1.647c-1.223-3.722-4.5-5.991-7.32-5.062a5.01 5.01 0 0 0 -3.155 3.817 4.274 4.274 0 0 1 1.824-1.184",
    transform: "translate(-526.36 -309.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.435 338.792a7.968 7.968 0 0 1 .069-1.61 9.115 9.115 0 0 0 -2.306 3.765 8.421 8.421 0 0 1 2.237-2.155",
    transform: "translate(-538.386 -313.609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.177 323.48a7.972 7.972 0 0 1 .069-1.61 8.958 8.958 0 0 0 -1.753 2.4 9.292 9.292 0 0 0 -.553 1.365 8.322 8.322 0 0 1 2.237-2.156",
    transform: "translate(-542.154 -306.158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.382 402.94a8.883 8.883 0 0 1 -.366 1.607 9.428 9.428 0 0 0 1.365-2.742 8.638 8.638 0 0 1 -1 1.135z",
    transform: "translate(-534.405 -345.054)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m598.468 254.221a8.668 8.668 0 0 0 3.012-3.411c1.8-3.55 1.054-7.543-1.658-8.915s-6.369.4-8.166 3.949a8.672 8.672 0 0 0 -.959 4.458 9.014 9.014 0 0 0 -3.975 7.858 8.64 8.64 0 0 0 -3.012 3.412 9.069 9.069 0 0 0 -.553 1.35 7.635 7.635 0 0 1 3.939-2.928 4.479 4.479 0 0 0 5.64 2.885l.048-.015a7.631 7.631 0 0 1 0 4.907 9.293 9.293 0 0 0 .76-1.244 8.669 8.669 0 0 0 .96-4.447 8.993 8.993 0 0 0 3.974-7.858z",
    fill: "#3f3d56",
    transform: "translate(-532.574 -151.161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.652 120.889a26.372 26.372 0 0 0 3.191-1.768l-11.832-8.645 13.906 7.162a26.4 26.4 0 0 0 9.883-18.412l-23.636.242 23.687-3.96a26.352 26.352 0 1 0 -52.183 6.69 26.408 26.408 0 0 0 -4.853 2.928l12.352 17.174-14.83-15.036a26.381 26.381 0 0 0 -7.382 24.013 26.352 26.352 0 1 0 36.984 18.7 26.352 26.352 0 0 0 14.714-29.093",
    fill: "#4181ff",
    transform: "translate(-525.074 -68.205)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__e)",
    opacity: 0.1,
    transform: "translate(42.676 45.841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m585.294 155.033a26.269 26.269 0 0 0 -2.324 17.1 26.352 26.352 0 1 0 36.984 18.7c5.175-2.4-33.334-38.438-34.659-35.8",
    transform: "translate(-567.757 -154.895)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4181ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m656.05 65.606a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-566.14 -65.606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700.562 70.5a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-587.8 -67.986)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m717.727 138.975a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-596.152 -101.307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m694.559 173.171a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-584.879 -117.947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.907 244.195a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-569.477 -152.507)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__f)",
    opacity: 0.1,
    transform: "translate(89.518 91.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m662.907 244.195a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-658.994 -244.195)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m592.532 163.754a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    fill: "#4181ff",
    transform: "translate(-535.233 -113.364)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__g)",
    opacity: 0.1,
    transform: "translate(53.387 50.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m592.532 163.754a3.912 3.912 0 1 1 -3.912 3.912 3.912 3.912 0 0 1 3.912-3.912",
    transform: "translate(-588.62 -163.754)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__h)",
    opacity: 0.1,
    transform: "translate(50.047 110.186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m585.195 288.693c-2.6-1.313-3.386-5.036-1.87-8.469-.08.138-.158.282-.231.432-1.8 3.55-1.054 7.539 1.659 8.915s6.368-.4 8.161-3.946c.077-.146.143-.3.207-.443-1.863 3.258-5.329 4.828-7.927 3.51",
    transform: "translate(-582.113 -280.224)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__i)",
    opacity: 0.1,
    transform: "translate(46.182 117.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m577.666 303.575c-2.6-1.313-3.386-5.036-1.866-8.473-.08.143-.161.285-.234.432-1.8 3.55-1.054 7.543 1.659 8.915s6.368-.392 8.165-3.945c.073-.147.143-.293.207-.443-1.867 3.258-5.329 4.828-7.931 3.514",
    transform: "translate(-574.586 -295.102)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__j)",
    opacity: 0.1,
    transform: "translate(42.318 125.466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.139 318.456c-2.6-1.313-3.386-5.036-1.866-8.469-.081.138-.161.282-.234.432-1.8 3.55-1.05 7.539 1.659 8.915s6.364-.4 8.162-3.946c.073-.146.143-.3.207-.443-1.86 3.258-5.326 4.828-7.927 3.51",
    transform: "translate(-567.06 -309.987)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__k)",
    opacity: 0.1,
    transform: "translate(38.465 133.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m562.637 333.376c-2.6-1.313-3.386-5.036-1.87-8.469-.081.138-.158.282-.234.428-1.793 3.55-1.05 7.543 1.659 8.915s6.368-.4 8.161-3.949c.077-.146.143-.293.207-.443-1.868 3.243-5.336 4.813-7.923 3.517",
    transform: "translate(-559.554 -324.907)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__l)",
    opacity: 0.1,
    transform: "translate(34.591 140.746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m555.09 348.218c-2.6-1.313-3.387-5.036-1.87-8.469q-.121.207-.231.432c-1.8 3.55-1.054 7.539 1.659 8.915s6.368-.4 8.165-3.945c.073-.146.143-.3.207-.443-1.859 3.258-5.332 4.828-7.93 3.51",
    transform: "translate(-552.009 -339.749)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__m)",
    opacity: 0.1,
    transform: "translate(30.726 148.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547.562 363.1c-2.6-1.313-3.387-5.036-1.867-8.47-.081.139-.161.282-.234.429-1.8 3.55-1.055 7.543 1.658 8.915s6.35-.4 8.18-3.949c.073-.146.143-.293.207-.443-1.881 3.262-5.329 4.832-7.945 3.518",
    transform: "translate(-544.481 -354.632)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__n)",
    opacity: 0.1,
    transform: "translate(26.864 156.025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m540.036 377.98c-2.6-1.313-3.386-5.036-1.866-8.47-.08.143-.158.282-.234.432-1.793 3.55-1.05 7.539 1.659 8.915s6.368-.4 8.162-3.945c.077-.147.143-.3.207-.443-1.86 3.259-5.324 4.829-7.927 3.511",
    transform: "translate(-536.958 -369.51)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__o)",
    opacity: 0.1,
    transform: "translate(23 163.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m532.513 392.865c-2.6-1.313-3.386-5.036-1.87-8.469q-.121.207-.231.428c-1.8 3.55-1.054 7.543 1.659 8.915s6.368-.4 8.165-3.949c.073-.146.138-.293.207-.443-1.866 3.261-5.332 4.816-7.931 3.517",
    transform: "translate(-529.432 -384.396)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__p)",
    opacity: 0.1,
    transform: "translate(20.461 168.686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.566 402.643c-2.6-1.317-3.386-5.036-1.866-8.473-.08.143-.161.285-.234.432-1.8 3.55-1.054 7.543 1.659 8.915s6.368-.392 8.165-3.945c.073-.146.143-.293.207-.443-1.867 3.258-5.333 4.828-7.931 3.514",
    transform: "translate(-524.486 -394.17)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m630.015 325.886a13.692 13.692 0 0 0 .732-3.584 1.954 1.954 0 1 0 -.3-3.887 13.654 13.654 0 0 0 -7.188-9.261 1.956 1.956 0 1 0 -3.491-1.765 1.833 1.833 0 0 0 -.176.523 13.72 13.72 0 0 0 -12.03 3.605 13.767 13.767 0 0 0 -3.594-.107l-1.586 7.217-.1-6.954a13.7 13.7 0 1 0 7.32 26.352 1.933 1.933 0 0 0 .824.79 1.954 1.954 0 0 0 2.68-2.517 13.734 13.734 0 0 0 1.757-1.435 13.707 13.707 0 0 0 14.387-7.256l-7.375-1.244z",
    fill: "#4181ff",
    transform: "translate(-536.646 -182.735)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__q)",
    opacity: 0.1,
    transform: "translate(54.861 128.152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m618.6 333.723c-2.723-3.594-4.392-7.85-6.313-11.935a49.771 49.771 0 0 0 -2.588-4.89l-1.442-1.68c-.241.207-.484.415-.732.641a13.784 13.784 0 0 0 -3.593-.106l-1.585 7.214-.1-6.954a13.7 13.7 0 1 0 7.32 26.352 1.956 1.956 0 0 0 3.5-1.728 13.727 13.727 0 0 0 1.757-1.434 13.721 13.721 0 0 0 8.213-1.215 19.282 19.282 0 0 1 -4.443-4.264z",
    transform: "translate(-591.491 -315.219)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m518.388 295.038a1.955 1.955 0 0 0 -1.749-2.833 13.677 13.677 0 0 0 -4.285-7.624 13.739 13.739 0 0 0 .4-4.285l-7.192-1.226 6.98-.439a13.854 13.854 0 0 0 -.516-1.935 2 2 0 0 0 .644-.732 1.958 1.958 0 0 0 -2.412-2.723 13.7 13.7 0 0 0 -24.444 11.317 1.922 1.922 0 0 0 -.974.915 1.955 1.955 0 0 0 2.471 2.7 13.731 13.731 0 0 0 2.595 3.166 13.69 13.69 0 0 0 .637 8.7l9.646-2.5-8.6 4.524a13.7 13.7 0 0 0 25.22-5.951 1.952 1.952 0 0 0 1.574-1.065z",
    fill: "#4181ff",
    transform: "translate(-484.633 -163.826)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__r)",
    opacity: 0.1,
    transform: "translate(4.852 120.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.987 310.611a1.955 1.955 0 0 0 -1.749-2.833 13.677 13.677 0 0 0 -4.285-7.624c.059-.231.11-.457.154-.691a4.844 4.844 0 0 0 -.706.626c-1.3 1.424-1.965 3.338-3.248 4.776a9.362 9.362 0 0 1 -6.049 2.822 23.065 23.065 0 0 1 -6.782-.545 19.529 19.529 0 0 0 -5.607-.611 3.165 3.165 0 0 0 -.534.069c.11.106.22.212.333.315a13.691 13.691 0 0 0 .637 8.7l9.644-2.507-8.6 4.524a13.7 13.7 0 0 0 25.22-5.951 1.95 1.95 0 0 0 1.574-1.065z",
    transform: "translate(-494.083 -299.462)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__s)",
    opacity: 0.1,
    transform: "translate(0 116.894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.09 348.5c.469-1.424 2.368-2.079 4.242-1.464a4.639 4.639 0 0 1 .78.337c.121-.033.245-.063.366-.085a4.126 4.126 0 0 1 -.117-1.252 4.56 4.56 0 0 1 -2-3.96 4.549 4.549 0 0 1 -2-3.956 4.39 4.39 0 0 1 -1.515-1.72c-.9-1.786-.534-3.8.838-4.492s3.209.2 4.113 1.987a4.394 4.394 0 0 1 .484 2.243 4.529 4.529 0 0 1 2 3.957 4.538 4.538 0 0 1 2 3.96 4.528 4.528 0 0 1 2 3.957 4.384 4.384 0 0 1 1.52 1.72 4.625 4.625 0 0 1 .367 1.062 3.878 3.878 0 0 1 .816-.875 4.6 4.6 0 0 1 .19-.83c.619-1.873 2.269-3.016 3.692-2.562s2.073 2.368 1.464 4.242a4.27 4.27 0 0 1 -1.394 2.045 4.683 4.683 0 0 1 -.19.83 4.063 4.063 0 0 1 -1.87 2.349 4.759 4.759 0 0 1 .154.732 4.61 4.61 0 0 1 .926 1.256 4.5 4.5 0 0 1 .461 1.493 4.6 4.6 0 0 1 .924 1.257 4.67 4.67 0 0 0 1.39 2.752c.9 1.786.531 3.8-.834 4.488s-3.21-.2-4.114-1.988a4.568 4.568 0 0 1 -.461-1.493c-.927-1.832-1.849-3.668-2.782-5.5a4.6 4.6 0 0 1 -.93-1.255 4.655 4.655 0 0 1 -.461-1.493 4.61 4.61 0 0 1 -.926-1.256 4.516 4.516 0 0 1 -.461-1.493 4.255 4.255 0 0 1 -.626-.732 4.359 4.359 0 0 1 -2.262-.139 4.872 4.872 0 0 1 -.783-.34 4.252 4.252 0 0 1 -2.47-.088c-1.854-.621-3-2.272-2.535-3.7",
    fill: "#3f3d56",
    transform: "translate(-30.338 -278.283)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__t)",
    opacity: 0.1,
    transform: "translate(32.665 58.365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.232 353.521a3.945 3.945 0 0 0 .637.509 4.133 4.133 0 0 0 .207 1.551 4.4 4.4 0 0 1 -.388-.633 4.572 4.572 0 0 1 -.456-1.427",
    transform: "translate(-66.839 -347.281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.332 345.823a4.109 4.109 0 0 0 .637.505 4.154 4.154 0 0 0 .207 1.556 4.652 4.652 0 0 1 -.844-2.061",
    transform: "translate(-64.942 -343.535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.165 342.18a4.059 4.059 0 0 0 -.029-.813 4.629 4.629 0 0 1 .882 1.212 4.839 4.839 0 0 1 .277.691 4.184 4.184 0 0 0 -1.131-1.087z",
    transform: "translate(-69.226 -341.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.264 388.33a4.285 4.285 0 0 0 -.542-.622 4.516 4.516 0 0 0 -.161-.732 4.86 4.86 0 0 1 .421.681 4.771 4.771 0 0 1 .282.673",
    transform: "translate(-80.624 -363.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.54 382.977a1.562 1.562 0 0 1 -.7-1.354 4.641 4.641 0 0 1 .691 1.347z",
    transform: "translate(-79.302 -360.955)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.023 361.2a3.7 3.7 0 0 0 .633.5 3.984 3.984 0 0 0 .117 1.252 3.705 3.705 0 0 0 -.367.084 4.813 4.813 0 0 0 -.783-.336c-1.873-.615-3.774.04-4.239 1.464a2.133 2.133 0 0 0 -.062 1.1 2.537 2.537 0 0 1 -.607-2.419c.469-1.424 2.368-2.079 4.242-1.464a4.679 4.679 0 0 1 .78.337c.121-.033.245-.062.366-.084a3.868 3.868 0 0 1 -.08-.433",
    transform: "translate(-63.624 -350.993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.271 392.3a4.7 4.7 0 0 1 .421.684 4.756 4.756 0 0 1 .282.691 4.31 4.31 0 0 0 -.542-.626 4.562 4.562 0 0 0 -.161-.749",
    transform: "translate(-81.943 -366.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.064 349.9a4.06 4.06 0 0 0 -.029-.813 4.567 4.567 0 0 1 .882 1.212 4.752 4.752 0 0 1 .277.684 4.176 4.176 0 0 0 -1.129-1.083",
    transform: "translate(-71.123 -345.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.246 381.56a4.354 4.354 0 0 0 .18.8 4.61 4.61 0 0 1 -.691-1.382 4.267 4.267 0 0 0 .511.577",
    transform: "translate(-73.41 -360.644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.665 392.284a4.6 4.6 0 0 0 .183.8 4.314 4.314 0 0 1 -.388-.633 4.721 4.721 0 0 1 -.3-.732 4.831 4.831 0 0 0 .5.56",
    transform: "translate(-76.05 -365.871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.959 386.931a4.356 4.356 0 0 0 .179.805 4.7 4.7 0 0 1 -.388-.633 4.631 4.631 0 0 1 -.3-.732 4.342 4.342 0 0 0 .509.56",
    transform: "translate(-74.731 -363.266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.558 376.219a4.361 4.361 0 0 0 .179.809 4.567 4.567 0 0 1 -.367-.633 4.493 4.493 0 0 1 -.3-.732 4.051 4.051 0 0 0 .491.556",
    transform: "translate(-72.112 -358.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.737 361.858c-1.424-.469-3.074.673-3.689 2.562a4.64 4.64 0 0 0 -.19.829 3.894 3.894 0 0 0 -.819.871 4.7 4.7 0 0 0 -.385-1.061c-.062-.124-.132-.245-.207-.367a3.921 3.921 0 0 1 .732-.769 4.6 4.6 0 0 1 .19-.829c.619-1.873 2.269-3.016 3.693-2.562a2.537 2.537 0 0 1 1.59 1.925 2.17 2.17 0 0 0 -.914-.6",
    transform: "translate(-76.189 -350.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.861 365.313a4.058 4.058 0 0 0 -.029-.813 4.567 4.567 0 0 1 .882 1.212 4.839 4.839 0 0 1 .277.691 4.139 4.139 0 0 0 -1.131-1.087z",
    transform: "translate(-74.917 -352.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.964 357.6a4.058 4.058 0 0 0 -.029-.813 4.692 4.692 0 0 1 .882 1.213 4.839 4.839 0 0 1 .277.691 4.18 4.18 0 0 0 -1.129-1.09",
    transform: "translate(-73.021 -348.87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.374 397.639a4.369 4.369 0 0 0 .183.809 4.548 4.548 0 0 1 -.388-.637 4.721 4.721 0 0 1 -.3-.732 4.825 4.825 0 0 0 .5.56",
    transform: "translate(-77.368 -368.476)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m56.567 322.706a4.363 4.363 0 0 1 -1.515-1.717c-.9-1.79-.531-3.8.834-4.492s3.209.2 4.113 1.988a4.365 4.365 0 0 1 .484 2.24 4.537 4.537 0 0 1 2 3.96 4.393 4.393 0 0 1 1.521 1.717 4.9 4.9 0 0 1 .276.681 3.868 3.868 0 0 0 -1.987-1.464 2.255 2.255 0 0 1 -2.826 1.477l-.041-.013a3.854 3.854 0 0 0 0 2.47 4.828 4.828 0 0 1 -.366-.626 4.385 4.385 0 0 1 -.484-2.239 4.549 4.549 0 0 1 -2-3.96z",
    fill: "#3f3d56",
    transform: "translate(-26.548 -270.786)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.358 255.387a13.53 13.53 0 0 1 -1.607-.889l5.959-4.354-7.005 3.6a13.3 13.3 0 0 1 -4.976-9.275l11.909.125-11.938-1.994a13.282 13.282 0 1 1 26.282 3.367 13.425 13.425 0 0 1 2.445 1.464l-6.22 8.652 7.471-7.569a13.294 13.294 0 0 1 3.722 12.093 13.282 13.282 0 1 1 -18.629 9.421 13.278 13.278 0 0 1 -7.411-14.64z",
    fill: "#4181ff",
    transform: "translate(-.343 -228.845)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__u)",
    opacity: 0.1,
    transform: "translate(15.165 23.098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.258 272.745a13.223 13.223 0 0 1 1.172 8.612 13.282 13.282 0 1 1 -18.629 9.42c-2.61-1.212 16.788-19.361 17.458-18.032",
    transform: "translate(-29.538 -272.675)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4181ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.039 227.685a1.972 1.972 0 1 1 -1.972 1.973 1.972 1.972 0 0 1 1.972-1.973",
    transform: "translate(-15.117 -227.685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.611 230.151a1.972 1.972 0 1 1 -1.972 1.972 1.972 1.972 0 0 1 1.972-1.972",
    transform: "translate(-4.204 -228.885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.972 264.648a1.972 1.972 0 1 1 -1.972 1.973 1.972 1.972 0 0 1 1.972-1.973",
    transform: "translate(0 -245.671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.641 281.878a1.973 1.973 0 1 1 -1.972 1.973 1.972 1.972 0 0 1 1.972-1.973",
    transform: "translate(-5.678 -254.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.582 317.657a1.973 1.973 0 1 1 -1.972 1.972 1.972 1.972 0 0 1 1.972-1.972",
    transform: "translate(-13.435 -271.465)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__v)",
    opacity: 0.1,
    transform: "translate(14.175 46.192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.582 317.657a1.973 1.973 0 1 1 -1.972 1.972 1.972 1.972 0 0 1 1.972-1.972",
    transform: "translate(-27.61 -317.657)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m65.033 277.13a1.973 1.973 0 1 1 -1.972 1.973 1.973 1.973 0 0 1 1.972-1.973",
    fill: "#4181ff",
    transform: "translate(-30.685 -251.745)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__w)",
    opacity: 0.1,
    transform: "translate(32.376 25.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.033 277.13a1.973 1.973 0 1 1 -1.972 1.973 1.973 1.973 0 0 1 1.972-1.973",
    transform: "translate(-63.061 -277.13)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__x)",
    opacity: 0.1,
    transform: "translate(32.455 55.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.213 340.074c1.313-.662 1.706-2.536.941-4.267.04.073.081.143.117.216.9 1.79.53 3.8-.838 4.492s-3.206-.2-4.11-1.987c-.036-.073-.073-.146-.106-.223.941 1.643 2.687 2.433 4 1.77",
    transform: "translate(-63.216 -335.806)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__x)",
    opacity: 0.1,
    transform: "translate(34.402 59.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71 347.573c1.313-.663 1.709-2.54.944-4.267.04.069.081.143.117.216.9 1.79.531 3.8-.838 4.492s-3.206-.2-4.11-1.988c-.04-.073-.073-.15-.106-.223.941 1.65 2.69 2.431 3.994 1.771",
    transform: "translate(-67.008 -343.305)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__y)",
    opacity: 0.1,
    transform: "translate(36.35 63.207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.8 355.065c1.313-.663 1.709-2.536.941-4.267.044.073.081.143.121.22.9 1.786.527 3.8-.838 4.487s-3.206-.2-4.11-1.987c-.04-.073-.073-.147-.106-.223.937 1.643 2.683 2.434 3.993 1.771",
    transform: "translate(-70.803 -350.798)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__z)",
    opacity: 0.1,
    transform: "translate(38.298 67.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.589 362.564c1.313-.663 1.709-2.536.941-4.267.04.069.081.143.117.216.907 1.79.53 3.8-.834 4.492s-3.21-.2-4.113-1.988c-.037-.073-.069-.15-.1-.223.936 1.638 2.683 2.432 3.993 1.77",
    transform: "translate(-74.596 -358.297)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__A)",
    opacity: 0.1,
    transform: "translate(40.241 70.908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.377 370.062c1.313-.662 1.706-2.536.941-4.264.04.069.081.143.117.216.9 1.79.53 3.8-.834 4.492s-3.21-.2-4.113-1.987c-.037-.077-.069-.15-.107-.223.941 1.636 2.687 2.429 4 1.767",
    transform: "translate(-78.38 -365.798)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__B)",
    opacity: 0.1,
    transform: "translate(42.186 74.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.166 377.549c1.313-.663 1.706-2.536.941-4.267.04.073.081.143.117.216.9 1.79.53 3.8-.834 4.492s-3.21-.2-4.113-1.988c-.037-.073-.073-.146-.107-.223.943 1.632 2.689 2.435 4 1.77",
    transform: "translate(-82.169 -373.282)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__C)",
    opacity: 0.1,
    transform: "translate(44.134 78.604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.961 385.057c1.307-.663 1.706-2.54.941-4.267.04.069.081.143.117.216.9 1.79.53 3.8-.838 4.492s-3.206-.2-4.11-1.988c-.036-.077-.073-.15-.106-.223.941 1.639 2.687 2.433 4 1.771",
    transform: "translate(-85.964 -380.789)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__y)",
    opacity: 0.1,
    transform: "translate(46.082 82.451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m93.75 392.548c1.313-.662 1.709-2.536.941-4.267.044.073.081.143.121.22.9 1.786.527 3.8-.838 4.487s-3.206-.2-4.11-1.987c-.04-.073-.073-.147-.106-.223.941 1.643 2.683 2.434 3.993 1.771",
    transform: "translate(-89.757 -388.281)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__y)",
    opacity: 0.1,
    transform: "translate(47.37 84.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.263 397.475c1.313-.663 1.706-2.536.941-4.267.04.073.081.143.117.22.9 1.786.53 3.8-.834 4.487s-3.21-.2-4.113-1.987c-.037-.073-.073-.147-.107-.223.93 1.65 2.675 2.431 4 1.771",
    transform: "translate(-92.266 -393.207)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m30.235 358.8a6.794 6.794 0 0 1 -.366-1.8.985.985 0 1 1 0-1.969.955.955 0 0 1 .154.012 6.887 6.887 0 0 1 3.62-4.666.986.986 0 1 1 1.747-.915l.013.026a.885.885 0 0 1 .088.263 6.926 6.926 0 0 1 6.061 1.83 6.828 6.828 0 0 1 1.83-.051l.8 3.63.018-3.5a6.9 6.9 0 0 1 -3.095 13.44q-.3-.07-.6-.167a1.012 1.012 0 0 1 -.415.4.989.989 0 0 1 -1.354-1.271 6.863 6.863 0 0 1 -.882-.732 6.906 6.906 0 0 1 -7.247-3.663l3.715-.626z",
    fill: "#4181ff",
    transform: "translate(-14.054 -286.681)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__D)",
    opacity: 0.1,
    transform: "translate(19.658 64.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.551 362.755a33.2 33.2 0 0 0 3.179-6.012 24.351 24.351 0 0 1 1.3-2.466l.732-.846c.124.107.245.212.367.322a6.826 6.826 0 0 1 1.83-.051l.8 3.63.011-3.492a6.9 6.9 0 1 1 -3.088 13.449q-.3-.069-.6-.167a1.007 1.007 0 0 1 -.414.4.988.988 0 0 1 -1.354-1.27 6.92 6.92 0 0 1 -.882-.732 6.952 6.952 0 0 1 -4.14-.611 9.725 9.725 0 0 0 2.258-2.155z",
    transform: "translate(-38.29 -353.431)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89.906 343.274a.981.981 0 0 1 .43-1.318h.006a.964.964 0 0 1 .447-.106 6.9 6.9 0 0 1 2.154-3.85 6.866 6.866 0 0 1 -.2-2.155l3.62-.608-3.517-.223a6.8 6.8 0 0 1 .263-.974.969.969 0 0 1 -.326-.367.988.988 0 0 1 1.217-1.373 6.82 6.82 0 0 1 2.515-2.17 6.895 6.895 0 0 1 9.8 7.869.985.985 0 0 1 -.754 1.819 6.854 6.854 0 0 1 -1.307 1.589 6.917 6.917 0 0 1 -.318 4.392l-4.842-1.274 4.33 2.281a6.9 6.9 0 0 1 -12.015-.563 6.993 6.993 0 0 1 -.71-2.434.977.977 0 0 1 -.787-.539",
    fill: "#4181ff",
    transform: "translate(-43.696 -277.172)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__E)",
    opacity: 0.1,
    transform: "translate(46.103 60.485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.906 351.114a.981.981 0 0 1 .43-1.318h.006a.964.964 0 0 1 .447-.106 6.9 6.9 0 0 1 2.155-3.843c-.029-.113-.054-.23-.076-.345a2.634 2.634 0 0 1 .366.315c.655.732.992 1.68 1.636 2.4a4.729 4.729 0 0 0 3.049 1.424 11.535 11.535 0 0 0 3.415-.277 10.019 10.019 0 0 1 2.825-.311l.271.036-.169.158a6.915 6.915 0 0 1 -.318 4.392l-4.853-1.274 4.33 2.281a6.9 6.9 0 0 1 -12.016-.564 7 7 0 0 1 -.71-2.434.977.977 0 0 1 -.787-.533",
    transform: "translate(-89.799 -345.497)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__F)",
    opacity: 0.1,
    transform: "translate(104.561 9.136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m225.862 27.657a7.4 7.4 0 0 0 -4.3.469 6.341 6.341 0 0 1 -5.16 0 7.23 7.23 0 0 0 -6.068.121 3.756 3.756 0 0 1 -1.746.435c-2.46 0-4.506-2.478-4.93-5.746a4.785 4.785 0 0 0 1.229-1.325 6.915 6.915 0 0 1 12.342-.044 4.758 4.758 0 0 0 4.085 2.248h.069c1.936-.012 3.63 1.558 4.475 3.842",
    fill: "#4181ff",
    transform: "translate(-203.662 -17.795)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__G)",
    opacity: 0.1,
    transform: "translate(104.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.324 8.751-3.975 2.521 2.413-4.392a3.93 3.93 0 0 0 -2.4-.856h-.062a4.713 4.713 0 0 1 -.824-.063l-1.35.856.579-1.05a4.827 4.827 0 0 1 -2.357-1.775l-2.419 1.511 1.52-2.77a7.053 7.053 0 0 0 -5.402-2.733 7.392 7.392 0 0 0 -6.186 3.817 4.619 4.619 0 0 1 -4.088 2.2h-.121c-2.764 0-5.014 3.136-5.014 7.013s2.248 7.008 5.014 7.008a3.768 3.768 0 0 0 1.748-.438 7.217 7.217 0 0 1 6.068-.117 6.358 6.358 0 0 0 5.161 0 7.226 7.226 0 0 1 6.012.117 3.79 3.79 0 0 0 1.728.424c2.771 0 5.014-3.136 5.014-7.008a8.911 8.911 0 0 0 -1.054-4.264z",
    fill: "#4181ff",
    transform: "translate(-203.639)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__H)",
    opacity: 0.1,
    transform: "translate(12.331 55.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.735 122.391a10.61 10.61 0 0 0 -6.138.666 9.045 9.045 0 0 1 -7.371-.018 10.329 10.329 0 0 0 -8.667.172 5.394 5.394 0 0 1 -2.5.622c-3.514 0-6.438-3.539-7.045-8.209a6.742 6.742 0 0 0 1.757-1.892c2.061-3.317 5.252-5.453 8.835-5.453s6.734 2.108 8.784 5.391a6.778 6.778 0 0 0 5.856 3.209h.091c2.778 0 5.2 2.241 6.394 5.512",
    fill: "#4181ff",
    transform: "translate(-24.018 -108.279)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__I)",
    opacity: 0.1,
    transform: "translate(12.291 42.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.384 95.374-5.68 3.6 3.448-6.27a5.613 5.613 0 0 0 -3.437-1.226h-.091a6.661 6.661 0 0 1 -1.178-.088l-1.918 1.244.829-1.5a6.837 6.837 0 0 1 -3.367-2.562l-3.448 2.2 2.17-3.989a10.088 10.088 0 0 0 -7.719-3.9c-3.584 0-6.773 2.13-8.835 5.449a6.606 6.606 0 0 1 -5.858 3.148h-.2c-3.957 0-7.162 4.483-7.162 10.018s3.206 10.017 7.162 10.017a5.344 5.344 0 0 0 2.5-.626 10.327 10.327 0 0 1 8.666-.169 9.044 9.044 0 0 0 7.371.018 10.34 10.34 0 0 1 8.594.165 5.362 5.362 0 0 0 2.466.611c3.957 0 7.162-4.488 7.162-10.018a12.719 12.719 0 0 0 -1.476-6.122",
    fill: "#4181ff",
    transform: "translate(-23.941 -82.879)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__J)",
    opacity: 0.1,
    transform: "translate(273.751 23.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m533.208 55.443a7.407 7.407 0 0 1 4.3.469 6.328 6.328 0 0 0 5.157 0 7.232 7.232 0 0 1 6.068.121 3.77 3.77 0 0 0 1.746.435c2.459 0 4.509-2.478 4.933-5.746a4.741 4.741 0 0 1 -1.232-1.322 6.913 6.913 0 0 0 -12.349-.062 4.757 4.757 0 0 1 -4.092 2.258h-.063c-1.946-.005-3.644 1.565-4.468 3.85",
    fill: "#4181ff",
    transform: "translate(-533.208 -45.562)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__K)",
    opacity: 0.1,
    transform: "translate(265.223 14.292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m517.629 36.571 3.974 2.514-2.419-4.392a3.938 3.938 0 0 1 2.4-.856h.069a4.807 4.807 0 0 0 .823-.062l1.347.856-.579-1.05a4.838 4.838 0 0 0 2.379-1.768l2.412 1.53-1.526-2.77a7.036 7.036 0 0 1 5.406-2.734 7.391 7.391 0 0 1 6.185 3.817 4.617 4.617 0 0 0 4.088 2.2h.132c2.77 0 5.014 3.136 5.014 7.013s-2.244 7.008-5.014 7.008a3.789 3.789 0 0 1 -1.746-.435 7.217 7.217 0 0 0 -6.068-.117 6.348 6.348 0 0 1 -5.157 0 7.235 7.235 0 0 0 -6.017.117 3.777 3.777 0 0 1 -1.728.424c-2.764 0-5.014-3.136-5.014-7.008a8.915 8.915 0 0 1 1.032-4.285z",
    fill: "#4181ff",
    transform: "translate(-516.597 -27.838)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__L)",
    opacity: 0.1,
    transform: "translate(183.227 269.692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m398.975 525.3c23.245 0 42.089 3.277 42.089 7.32s-18.844 7.32-42.089 7.32-42.089-3.277-42.089-7.32 18.844-7.32 42.089-7.32",
    fill: "#4181ff",
    transform: "translate(-356.886 -525.303)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m334.149 443.307-65.216-.838.194-1.672 3.151-27.592h57.274l4.216 27.592.322 2.093z",
    fill: "#d0d2d5",
    transform: "translate(-130.862 -201.063)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__M)",
    opacity: 0.1,
    transform: "translate(138.072 239.733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m334.087 469.041h-32.544l-32.609-.421.194-1.672h64.638z",
    transform: "translate(-268.934 -466.948)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h86.539v2.09h-86.539z",
    fill: "#d0d2d5",
    transform: "translate(127.2 240.153)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m337.815 85.238a5.442 5.442 0 0 0 -5.417-5.46h-241.671a5.442 5.442 0 0 0 -5.417 5.468v146.488h252.505z",
    fill: "#bfbfbf",
    transform: "translate(-41.511 -38.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.31 372.9v17.158a5.417 5.417 0 0 0 5.417 5.417h241.673a5.417 5.417 0 0 0 5.417-5.417v-17.158z",
    fill: "#d0d2d5",
    transform: "translate(-41.512 -181.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h232.855v131.688h-232.855z",
    fill: "#fff",
    transform: "translate(54.251 50.145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.325 393.49a5.634 5.634 0 0 0 4.439-2.156 5.777 5.777 0 0 0 .439-.644l-3.1-.523 3.349.022a5.646 5.646 0 0 0 .107-4.469l-4.492 2.328 4.143-3.048a5.643 5.643 0 1 0 -4.886 8.487z",
    fill: "#4181ff",
    transform: "translate(-157.019 -185.976)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__N)",
    opacity: 0.1,
    transform: "translate(176.95 214.022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.66 416.868 26.019 26.132-3.993-26.132z",
    transform: "translate(-344.661 -416.868)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__O)",
    opacity: 0.1,
    transform: "translate(54.068 50.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h233.107v7.693h-233.107z",
    fill: "#444053"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__P)",
    opacity: 0.3,
    transform: "translate(135.004 51.499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m263.359 100.309h69.432a.4.4 0 0 1 .4.4v3.879a.4.4 0 0 1 -.4.4h-69.432a.4.4 0 0 1 -.4-.4v-3.878a.4.4 0 0 1 .4-.4",
    fill: "#4181ff",
    transform: "translate(-262.958 -100.309)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m393.165 103.6h-.172l-.062-.054a1.426 1.426 0 0 0 .33-.912 1.382 1.382 0 1 0 -1.382 1.395 1.43 1.43 0 0 0 .911-.333l.063.054v.172l1.072 1.072.318-.322zm-1.285 0a.958.958 0 1 1 .683-.282.959.959 0 0 1 -.683.282",
    fill: "#3f3d56",
    transform: "translate(-190.014 -49.274)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__Q)",
    opacity: 0.8,
    transform: "translate(56.849 52.597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.139 102.448a1.409 1.409 0 1 1 -1.409 1.409 1.409 1.409 0 0 1 1.409-1.409",
    fill: "#fa5959",
    transform: "translate(-110.73 -102.448)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__R)",
    opacity: 0.8,
    transform: "translate(60.725 52.597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m119.689 102.448a1.409 1.409 0 1 1 -1.409 1.409 1.409 1.409 0 0 1 1.409-1.409",
    fill: "#fed253",
    transform: "translate(-118.28 -102.448)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__R)",
    opacity: 0.8,
    transform: "translate(64.605 52.597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.245 102.448a1.409 1.409 0 1 1 -1.409 1.409 1.409 1.409 0 0 1 1.409-1.409",
    fill: "#8ccf4d",
    transform: "translate(-125.836 -102.448)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4181ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m331.872 201.17a15.624 15.624 0 0 0 -25.956 0 14.01 14.01 0 0 0 25.956 0",
    transform: "translate(-148.858 -94.519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.3 207.777a3.339 3.339 0 0 1 -.644-.366 2.582 2.582 0 0 1 -.71-.918 2.626 2.626 0 1 0 -4.29.637 2.944 2.944 0 0 0 .622.5 1.81 1.81 0 0 1 .7.732 5.286 5.286 0 0 0 1.215 1.6 10.656 10.656 0 0 0 1.666 1.171 24.274 24.274 0 0 0 -1.369 7.159 9.909 9.909 0 0 0 -2.789.45 4.5 4.5 0 0 0 -1.292.644 3 3 0 0 0 -.318-.022 2.631 2.631 0 1 0 2.463 3.557 1.681 1.681 0 0 1 1.358-1.1 6.217 6.217 0 0 1 .677-.044 23.568 23.568 0 0 0 3.129 9.761 7.678 7.678 0 0 0 -2.909 3.974 1.13 1.13 0 0 0 -.207.15 2.5 2.5 0 0 0 -.308.285 2.626 2.626 0 1 0 4.41.86 1.723 1.723 0 0 1 .428-1.859 7.355 7.355 0 0 1 .622-.534c2.968 3.466 6.5 5.688 10.91 5.951v-23.515a16.231 16.231 0 0 1 -13.364-9.072m36.537 11.611a2.88 2.88 0 0 0 -.319.022 4.946 4.946 0 0 0 -1.292-.644 9.811 9.811 0 0 0 -2.788-.45 24.8 24.8 0 0 0 -1.369-7.155 10.619 10.619 0 0 0 1.665-1.172 5.707 5.707 0 0 0 1.266-1.672 1.54 1.54 0 0 1 .647-.641 2.626 2.626 0 1 0 -3.663-1.16 2.5 2.5 0 0 1 -.71.918 6.965 6.965 0 0 1 -.644.472 16.12 16.12 0 0 1 -13.352 8.963v23.536c4.392-.263 7.947-2.5 10.91-5.951.231.183.425.346.589.5a1.779 1.779 0 0 1 .461 1.915 2.626 2.626 0 1 0 4.423-.853 2.49 2.49 0 0 0 -.308-.285c-.121-.1-.207-.15-.207-.15a7.573 7.573 0 0 0 -2.928-3.975 23.564 23.564 0 0 0 3.129-9.761 5.816 5.816 0 0 1 .648.044 1.756 1.756 0 0 1 1.409 1.1 2.626 2.626 0 0 0 5.069-.8 2.668 2.668 0 0 0 -2.529-2.8h-.1z",
    transform: "translate(-137.931 -98.642)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__S)",
    transform: "translate(187.246 160.384)"
  }, /*#__PURE__*/React.createElement("image", {
    height: 120.136,
    transform: "translate(-.367 -.109)",
    width: 62.635,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAADqCAYAAABtP1GnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKPSURBVHhe7dnRiQNBDAXBXYfiSCd0I/DnRKCugscF0GjMse855/uw3uf/l+WEjhA6QugIoSOEjpjQr+2fi44QOkLoCKEjhI4QOkLoCKEjhI4QOkLoCKEjhI4QOkLoiAl9/X5pu+aiI4SOEDpC6AihI4SOEDpC6AihI4SOEDpC6AihI4SOmNDXz1q2ay46QugIoSOEjhA6QugIoSOEjhA6QugIoSOEjhA6QuiICX39rGW75qIjhI4QOkLoCKEjhI4QOkLoCKEjhI4QOkLoCKEjhI4QOmJCX79f2q656AihI4SOEDpC6AihI4SOEDpC6AihI4SOEDpC6AihIyb09bOW7ZqLjhA6QugIoSOEjhA6QugIoSOEjhA6QugIoSOEjhA6QuiICX39fmm75qIjhI4QOkLoCKEjhI4QOkLoiAl9/Qfbds1FRwgd4emOzEVHCB3h6Y7MRUcIHeHpjsxFRwgdIXSE3+jIXHSE0BGe7shcdITQEZ7uyFx0hNARnu7IXHSE0BGe7shcdITQEZ7uyFx0hNARnu7IXHSE0BFCR/iNjsxFRwgd4emOzEVHCB3h6Y7MRUcIHeHpjsxFRwgd4emOzEVHCB3h6Y7MRUcIHSF0hN/oyFx0hNARnu7IXHSE0BGe7shcdITQEZ7uyFx0hNARnu7IXHSE0BGe7shcdITQEUJH+I2OzEVHCB3h6Y7MRUcIHeHpjsxFRwgd4emOzEVHCB3h6Y7MRUcIHeHpjsxFRwgdIXSE3+jIXHSE0BGe7shcdITQEZ7uyFx0hNARnu7IXHSE0BGe7shcdITQEZ7uyFx0hNARQkf4jY7MRUcIHeHpjsxFRwgd4emOzEVHCB3h6Y7MRUcIHeHpjsxFJzzPD44fGdyJo3dEAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m443.113 367.914q1.171 1.8 2.2 3.682a13.562 13.562 0 0 1 1.16 2.626c.424 1.464.414 3.027.732 4.52.367 1.757 1.223 3.433 1.223 5.234a7.527 7.527 0 0 1 -1.545 4.3 20.427 20.427 0 0 1 -3.228 3.33 68.667 68.667 0 0 1 -4.567-22.4 7.856 7.856 0 0 1 .346-3.147c.238-.622 1.382-2.328 2.115-1.659.268.245.337 1.351.5 1.72a13.292 13.292 0 0 0 1.068 1.793z",
    fill: "#2f2e41",
    transform: "translate(-213.64 -177.242)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__T)",
    opacity: 0.1,
    transform: "translate(225.409 187.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m443.113 367.914q1.171 1.8 2.2 3.682a13.562 13.562 0 0 1 1.16 2.626c.424 1.464.414 3.027.732 4.52.367 1.757 1.223 3.433 1.223 5.234a7.527 7.527 0 0 1 -1.545 4.3 20.427 20.427 0 0 1 -3.228 3.33 68.667 68.667 0 0 1 -4.567-22.4 7.856 7.856 0 0 1 .346-3.147c.238-.622 1.382-2.328 2.115-1.659.268.245.337 1.351.5 1.72a13.292 13.292 0 0 0 1.068 1.793z",
    fill: "#4181ff",
    transform: "translate(-439.049 -364.249)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m224.811 264.382c-2.9 2.892-3.243 4.165-4.982 4.74s-7.993 3.814-6.028 7.4l5.285 3.491.154.1.809 2.43-7.993 14.23s-13.176-6.024-14.468 2.887-.472 11.346-.819 16.1.113 6.134-1.047 6.134-1.618-3.126-1.618-3.126-.073-.143-.2-.41c-1.723-3.584-13.424-29.887 5.318-47.967 0 0 8.682-.571 10.771-10.526 1.442-6.881 6.485-6.289 9.838-4.886a11.124 11.124 0 0 1 3.008 1.768 14.806 14.806 0 0 1 2.156 2.562c.956 1.51 1.476 3.4-.182 5.064",
    fill: "#d0d2d5",
    transform: "translate(-91.828 -123.644)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__U)",
    opacity: 0.1,
    transform: "translate(101.264 156.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.39 304.7.809 2.43-7.993 14.229s-13.176-6.024-14.468 2.887-.472 11.346-.819 16.1.113 6.134-1.047 6.134-1.618-3.126-1.618-3.126-.073-.143-.2-.41c-.582-4.451-3.531-30.484 7.163-29.1 0 0 8.677 4.055 10.064 2.438 1.1-1.281 5.973-8.648 7.957-11.671z",
    transform: "translate(-197.241 -304.615)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__V)",
    opacity: 0.1,
    transform: "translate(117.225 131.325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m244.271 260.124-5.285 6.006s-6.138 8.213-7.411 7.865a5.925 5.925 0 0 0 -1.161-.138 2.255 2.255 0 0 1 -1.464-3.8c2.094-2.2 5.951-6.364 6.2-7.29a63.6 63.6 0 0 1 3.939-6.972 11.122 11.122 0 0 1 3.009 1.768 14.816 14.816 0 0 1 2.17 2.557z",
    transform: "translate(-228.33 -255.793)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.427 372.341c-.9 1.793-5.49 8.52-7.5 11.459l-.941 1.382s-.366 2.43-6.364-.582-146.94-62.481-146.94-62.481l-.955-2.869 6.954-10.413 154.475 59.683s2.431 1.5 1.271 3.821",
    fill: "#454b69",
    transform: "translate(-113.731 -150.279)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__W)",
    opacity: 0.1,
    transform: "translate(119.996 168.971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m388.927 393.67-.941 1.382s-.367 2.43-6.364-.582-146.941-62.481-146.941-62.481l-.955-2.869z",
    transform: "translate(-233.727 -329.12)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m365.387 379.058a5.134 5.134 0 0 0 -4.132.809 3.4 3.4 0 0 0 -1.186 2.254c-.1 1.014.494 2.218 1.511 2.294a4.851 4.851 0 0 0 .732-.048 10.969 10.969 0 0 1 1.918.161 7.829 7.829 0 0 0 6.672-2.7c.875-1.1-.276-1.574-1.313-1.793-1.409-.3-2.789-.755-4.2-.982",
    fill: "#fbbebe",
    transform: "translate(-175.204 -184.383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.788 434.782.907 6.449a9.823 9.823 0 0 1 .139 2.017 14.208 14.208 0 0 1 -1.5 4.285c-.582 1.4-.937 3.089-.164 4.392.238.407.571.754.787 1.175a4.728 4.728 0 0 1 .366 2.061l.249 9.149a57.634 57.634 0 0 0 8.484-.048.474.474 0 0 0 .308-.1.5.5 0 0 0 .106-.333c.124-2.142-.248-4.285-.128-6.427.044-.784.154-1.563.169-2.35.044-3.188-1.53-6.31-1.054-9.462a20.818 20.818 0 0 1 .585-2.353c1.5-5.49 1.186-11.258.853-16.927a.4.4 0 0 0 -.073-.256.387.387 0 0 0 -.2-.106 10.412 10.412 0 0 0 -9.435 1.793c-.4.322-1.406.633-1.669 1.017-.367.534.113 1.069.326 1.636a20.816 20.816 0 0 1 .941 4.381z",
    fill: "#3f3d56",
    transform: "translate(-202.126 -207.053)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__X)",
    opacity: 0.1,
    transform: "translate(213.262 218.459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m416.788 434.782.907 6.449a9.823 9.823 0 0 1 .139 2.017 14.208 14.208 0 0 1 -1.5 4.285c-.582 1.4-.937 3.089-.164 4.392.238.407.571.754.787 1.175a4.728 4.728 0 0 1 .366 2.061l.249 9.149a57.634 57.634 0 0 0 8.484-.048.474.474 0 0 0 .308-.1.5.5 0 0 0 .106-.333c.124-2.142-.248-4.285-.128-6.427.044-.784.154-1.563.169-2.35.044-3.188-1.53-6.31-1.054-9.462a20.818 20.818 0 0 1 .585-2.353c1.5-5.49 1.186-11.258.853-16.927a.4.4 0 0 0 -.073-.256.387.387 0 0 0 -.2-.106 10.412 10.412 0 0 0 -9.435 1.793c-.4.322-1.406.633-1.669 1.017-.367.534.113 1.069.326 1.636a20.816 20.816 0 0 1 .941 4.381z",
    transform: "translate(-415.389 -425.512)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m438.267 430.716a15.822 15.822 0 0 0 -1.26 2.672c-.665 2.522 1.058 5.124.853 7.708-.069.816-.318 1.611-.336 2.427a2.264 2.264 0 0 0 1.006 2.1c.484.249 1.1.223 1.556.508a2.512 2.512 0 0 1 .782 2.445 3.565 3.565 0 0 0 .367 2.61c.435.545 1.181.76 1.65 1.274a6.258 6.258 0 0 1 .706 1.193c.7 1.223 1.977 1.969 3.023 2.928s1.935 2.364 1.464 3.692a4.074 4.074 0 0 1 -2.242 2.031 23.757 23.757 0 0 1 -5.332 1.885 1.289 1.289 0 0 1 -.611.033 1.309 1.309 0 0 1 -.534-.367 9.942 9.942 0 0 1 -2.7-3.594 3.681 3.681 0 0 0 -.41-.981c-.571-.8-1.775-.772-2.588-1.325-.951-.648-1.182-1.935-1.8-2.9s-1.534-1.548-2.2-2.4c-1.12-1.421-1.395-3.318-2.2-4.937-.34-.691-.775-1.332-1.047-2.05a11.163 11.163 0 0 1 -.5-2.65c-.516-4.274-1.83-8.578-1-12.809.183-.929.465-1.83.582-2.788.2-1.659-.117-3.356.128-5.011a1.383 1.383 0 0 1 .553-1.065 1.46 1.46 0 0 1 .629-.128 42.9 42.9 0 0 1 6.507.146 4.038 4.038 0 0 1 2.986 1.226 6.551 6.551 0 0 1 .71 2.731 6.746 6.746 0 0 0 1.416 2.675c.615.9.288 1.793-.164 2.722",
    fill: "#3f3d56",
    transform: "translate(-206.634 -204.932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.442 496.267a2.566 2.566 0 0 1 1.665.33 2.2 2.2 0 0 1 .475 2.009 30.159 30.159 0 0 1 -1.566 5.856l-1.947 5.713a13.357 13.357 0 0 0 -.681 2.518 28.489 28.489 0 0 0 .138 4.392 3.442 3.442 0 0 1 -.505 2.133c-.83 1.065-2.441.94-3.77.732l-6.482-1.1a7.7 7.7 0 0 1 -1.6-.392 11.217 11.217 0 0 1 -1.556-.875 23.932 23.932 0 0 0 -4.026-1.83c-.607-.227-1.288-.516-1.508-1.127a1.581 1.581 0 0 1 1.037-1.83 5.612 5.612 0 0 1 2.294-.2 17.2 17.2 0 0 0 5.637-.76 3.558 3.558 0 0 0 1.486-.769 3.654 3.654 0 0 0 .856-1.724 25.648 25.648 0 0 0 .981-5.856c.077-1.464.026-2.928.085-4.392.036-.868-.048-3.663.714-4.257.582-.447 2.975.787 3.762.968a18.31 18.31 0 0 0 4.514.456",
    fill: "#2f2e41",
    transform: "translate(-191.252 -240.742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.407 499.732a62.565 62.565 0 0 1 1.142 6.471 10.531 10.531 0 0 0 2.734 5.855 3.627 3.627 0 0 1 .794.878 1.852 1.852 0 0 1 -.277 1.914 4.8 4.8 0 0 1 -1.607 1.234 37.265 37.265 0 0 1 -13.472 3.956 5.674 5.674 0 0 1 -2.5-.091 2.06 2.06 0 0 1 -1.489-1.83.934.934 0 0 1 .22-.633 1.37 1.37 0 0 1 .494-.289 14.575 14.575 0 0 0 4.816-2.792 5.342 5.342 0 0 0 1.659-5.073 10.052 10.052 0 0 0 -1.234-2.346 39.692 39.692 0 0 1 -1.83-3.547l-1.61-3.378a8.847 8.847 0 0 1 -1.028-3.1 14.857 14.857 0 0 0 5.936-.951 9.335 9.335 0 0 0 2.442-1.464c.622-.52 1.189-1.489 2.027-.813.673.542 1.1 2.067 1.493 2.84a20.839 20.839 0 0 1 1.286 3.154",
    fill: "#2f2e41",
    transform: "translate(-217.866 -240.138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.312 339.779c.161 1.406 1.52 2.331 2.822 2.887l-8.224 2.626a3.7 3.7 0 0 0 -.424-3.294 18.624 18.624 0 0 0 -1.464-2.346c-.08-.113-.172-.257-.113-.388a.412.412 0 0 1 .231-.18 20.692 20.692 0 0 1 5.281-1.808c.534-.077 1.544-.289 1.943.252s-.129 1.6-.052 2.25",
    fill: "#fbbebe",
    transform: "translate(-202.37 -164.066)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__Y)",
    opacity: 0.1,
    transform: "translate(213.519 173.105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m423.312 339.779c.161 1.406 1.52 2.331 2.822 2.887l-8.224 2.626a3.7 3.7 0 0 0 -.424-3.294 18.624 18.624 0 0 0 -1.464-2.346c-.08-.113-.172-.257-.113-.388a.412.412 0 0 1 .231-.18 20.692 20.692 0 0 1 5.281-1.808c.534-.077 1.544-.289 1.943.252s-.129 1.6-.052 2.25",
    transform: "translate(-415.89 -337.171)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m414.924 319.346a6.449 6.449 0 1 1 -6.449 6.449 6.449 6.449 0 0 1 6.449-6.449",
    fill: "#fbbebe",
    transform: "translate(-198.762 -155.393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.6 392.36a2.849 2.849 0 0 0 2.69.732c2.251-.367 4.092-2.024 6.3-2.621 2.7-.732 5.559.207 8.11 1.362s5.087 2.562 7.878 2.76c-2.522-5.621-1.079-12.385-3.491-18.054a14.463 14.463 0 0 1 -1.545-4.223c-.164-1.866.765-3.663.908-5.511a13.411 13.411 0 0 0 -.842-4.868l-1.765-5.8a22.193 22.193 0 0 0 -2.613-6.22c-.472-.684-.615-2.073-1.333-2.488-1.566-.9-3.939.235-5.64.3a5.881 5.881 0 0 0 -4.239 2.635 16.937 16.937 0 0 0 -2.2 4.856 46.217 46.217 0 0 0 -1.951 7.77c-.054.4-.1.791-.138 1.19-.366 3.759.169 7.539.2 11.316v.026c.036 4.791-.732 9.552-.875 14.34a3.827 3.827 0 0 0 .547 2.5",
    fill: "#4181ff",
    transform: "translate(-199.031 -168.889)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__Z)",
    opacity: 0.1,
    transform: "translate(210.585 181.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410.5 379.1a8.255 8.255 0 0 0 3.386-2.028 14.147 14.147 0 0 0 2.248-2.562 18.26 18.26 0 0 0 1.935-4.051 47.36 47.36 0 0 0 2.562-11.811 4.511 4.511 0 0 0 -.531-3.147 2.649 2.649 0 0 0 -3.2-.776 5.3 5.3 0 0 0 -1.943 2.09 27.01 27.01 0 0 0 -2.727 5.058c-.293.8-.508 1.618-.794 2.419a22.38 22.38 0 0 1 -1 2.316c-.054.4-.1.791-.138 1.19-.339 3.759.181 7.525.207 11.3",
    transform: "translate(-410.175 -354.477)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m403.7 354.118a4.533 4.533 0 0 1 .534 3.144 47.31 47.31 0 0 1 -2.562 11.811 18.091 18.091 0 0 1 -1.936 4.084 14.291 14.291 0 0 1 -2.247 2.562 7.009 7.009 0 0 1 -4.447 2.163 8.472 8.472 0 0 1 -2.765-.6l-13.738-4.682a5.585 5.585 0 0 1 .673-2.452l.732-2.17a2.759 2.759 0 0 1 1-1.574c.545-.326 1.409.121 1.866.484s.8.838 1.244 1.208a7.034 7.034 0 0 0 3.041 1.208l3.085.691a12.884 12.884 0 0 0 3.433.457c.861-2.626 2.5-4.94 3.422-7.547.285-.8.5-1.621.8-2.419a26.893 26.893 0 0 1 2.727-5.058 5.305 5.305 0 0 1 1.943-2.09 2.646 2.646 0 0 1 3.205.778",
    fill: "#4181ff",
    transform: "translate(-183.212 -171.814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.4 324.744a3.252 3.252 0 0 0 -.388-1.208 1.014 1.014 0 0 0 -1.1-.484c-.644.2-.861 1.2-1.534 1.229-.454.022-.78-.438-.923-.871a2.652 2.652 0 0 0 -.56-1.229 2.081 2.081 0 0 0 -.8-.367c-1.563-.494-3.179-1.406-3.7-2.961a1.771 1.771 0 0 1 -.084-.991c.238-.985 1.464-1.281 2.4-1.636a30.873 30.873 0 0 0 2.745-1.424 4.513 4.513 0 0 1 2.983-.552 15.434 15.434 0 0 1 1.5.56c1.515.527 3.371.282 4.545 1.376a4.7 4.7 0 0 1 1.1 1.918c.82 2.276 1.339 4.976-.018 6.976-.838 1.234-1.65 2.642-3.261 2.793-1.873.158-2.618-1.541-2.913-3.129",
    fill: "#2f2e41",
    transform: "translate(-198.184 -152.885)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__aa)",
    opacity: 0.1,
    transform: "translate(209.122 163.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m413.56 324.968a2.694 2.694 0 0 0 -.553-1.23 2.085 2.085 0 0 0 -.8-.366c-1.566-.494-3.178-1.406-3.7-2.961a1.81 1.81 0 0 1 -.08-.992 1.242 1.242 0 0 1 .195-.435 1.92 1.92 0 0 0 -1.263 1.212 1.778 1.778 0 0 0 .084.992c.52 1.556 2.134 2.466 3.7 2.961a2.087 2.087 0 0 1 .8.366 2.662 2.662 0 0 1 .56 1.23c.147.435.469.893.923.871s.673-.435.963-.783a1.166 1.166 0 0 1 -.823-.864",
    transform: "translate(-407.325 -318.984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.884 334.725c-1.881.172-2.627-1.541-2.928-3.118a3.2 3.2 0 0 0 -.367-1.208 1.016 1.016 0 0 0 -1.1-.484 1.945 1.945 0 0 0 -.809.732 1.1 1.1 0 0 1 .829.512 3.253 3.253 0 0 1 .388 1.208c.3 1.577 1.037 3.294 2.928 3.118a3.019 3.019 0 0 0 1.935-1 2.726 2.726 0 0 1 -.878.242",
    transform: "translate(-414.798 -324.291)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m568.444 463.061c6.527 0 11.818 1.018 11.818 2.273s-5.291 2.273-11.818 2.273-11.818-1.018-11.818-2.273 5.291-2.273 11.818-2.273",
    fill: "#4181ff",
    transform: "translate(-270.852 -225.324)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m577.955 462.1a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -224.856)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.955 457.807a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -222.767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.955 453.524a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -220.683)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.955 449.231a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -218.594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.955 444.94a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -216.506)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.955 440.657a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -214.422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.955 436.365a1.867 1.867 0 1 1 -1.376 1.8 1.632 1.632 0 0 1 1.376-1.8",
    transform: "translate(-280.561 -212.334)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m578.139 400.447a6.562 6.562 0 0 0 .512-.754l-3.615-.593 3.912.026a6.626 6.626 0 0 0 .124-5.222l-5.248 2.723 4.838-3.557a6.588 6.588 0 1 0 -10.876 7.378 6.56 6.56 0 0 0 -.754 1.2l4.7 2.441-5.007-1.68a6.587 6.587 0 0 0 1.065 6.178 6.588 6.588 0 1 0 10.361 0 6.588 6.588 0 0 0 0-8.151z",
    fill: "#4181ff",
    transform: "translate(-275.596 -189.67)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__ab)",
    opacity: 0.1,
    transform: "translate(290.769 214.744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m566.356 418.372a6.557 6.557 0 0 0 1.42 4.077 6.588 6.588 0 1 0 10.361 0c.875-1.124-11.781-4.816-11.781-4.077",
    transform: "translate(-566.356 -418.276)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89.679 547.437c9.4 0 17.015 1.465 17.015 3.271s-7.618 3.272-17.015 3.272-17.015-1.465-17.015-3.272 7.618-3.271 17.015-3.271",
    fill: "#4181ff",
    transform: "translate(-35.358 -266.381)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 546.048c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -265.705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 539.873c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -262.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 533.7c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -259.696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 527.527c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -256.693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 521.353c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -253.688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 515.173c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -250.681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.372 509c1.094 0 1.98 1.162 1.98 2.6s-.887 2.595-1.98 2.595-1.98-1.162-1.98-2.595.887-2.6 1.98-2.6",
    fill: "#3f3d56",
    transform: "translate(-49.337 -247.677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.6 457.236a10 10 0 0 0 .732-1.1l-5.2-.856 5.629.044a9.514 9.514 0 0 0 .179-7.521l-7.547 3.931 6.954-5.124a9.49 9.49 0 1 0 -15.676 10.614 9.44 9.44 0 0 0 -1.1 1.728l6.76 3.514-7.206-2.419a9.491 9.491 0 0 0 1.559 8.927 9.49 9.49 0 1 0 14.918 0 9.487 9.487 0 0 0 0-11.733z",
    fill: "#4181ff",
    transform: "translate(-42.154 -215.007)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error_img_svg__ac)",
    opacity: 0.1,
    transform: "translate(44.501 247.966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.678 483.129a9.461 9.461 0 0 0 2.031 5.854 9.49 9.49 0 1 0 14.918 0c1.262-1.617-16.949-6.935-16.949-5.854",
    transform: "translate(-86.678 -482.985)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImg);
export default __webpack_public_path__ + "static/media/error_img.1fda9af3aa680c3235fe50a8dc7ad907.svg";
export { ForwardRef as ReactComponent };